import React from 'react'

import { ModalInjectedProps } from '@sketch/components'

import { ProjectFragment } from '@sketch/gql-types'
import ProjectIdentityModalContent, {
  FormProps,
} from '../ProjectIdentityContent'
import { useCreateProject } from '../../hooks/useCreateProject'
import { useFolderTerm } from '@sketch/modules-common'

interface CreateNestedProjectModalProps extends ModalInjectedProps {
  project: ProjectFragment
  workspaceIdentifier: string
}

export const CreateNestedProjectModal = (
  props: CreateNestedProjectModalProps
) => {
  const { project, workspaceIdentifier, hideModal } = props

  const { createProject, loading } = useCreateProject({
    onCompleted: () => hideModal?.(),
  })

  const handleSubmit = (values: FormProps) => {
    createProject({
      variables: {
        name: values.name,
        description: values.description ?? '',
        workspaceId: workspaceIdentifier,
        parentProjectIdentifier: project.identifier,
      },
    })
  }

  const folderTerm = useFolderTerm()

  return (
    <ProjectIdentityModalContent
      title={`Create a ${folderTerm.upper} inside “${project.name}”`}
      onSubmit={handleSubmit}
      isLoading={loading}
      hideModal={hideModal}
    />
  )
}
